import axios from 'axios';

const urlApi = process.env.REACT_APP_API_ENDPOINT


const api_GET = (endpoint, tenantId) => {

  const promise = new Promise((resolve, reject) => { 

      try 
      {
          const urlComplete = urlApi+endpoint;                            
          const headers = {headers: {'Content-Type': 'application/json', 'tenantId': tenantId}};
          return axios.get(urlComplete, headers)
          .then(result => {          
            let newResult = {
              status: result.status,
              data: result.data,
              headers: result.headers
            }  
            resolve(newResult);
          })
          .catch(function (error) {
            if (error.response) {
              if (error.response.status === 401 || error.response.status === 403){
                window.location.reload();
                return;   
              }
              
              let message = "";
              if(error.response.data.message)
                message = error.response.data.message;
              else
                message = "Erro inesperado";

              let newError = {
                status: error.response.data.status,
                message:message
              }   
              resolve(newError);
            }
            else
            {
              let result = {
                status: 500,
                message:"Erro ao conectar com api."
              }           
              resolve(result);
            } 
          });
        
      } catch (error) {
        let result = {
          status: 500,
          message:"Erro no servidor."
        }
        resolve(result);
      }  

  });

  return promise;

};

export { api_GET };